<template>
  <div class="producttypefile-list">
    <Toolbar :handle-add="() => addHandlerSpecial()"  v-if="userHasAccess('producttypefile_edit') && hasLinkProduct"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-file-document-edit-outline</v-icon>{{$t('qualitycheck.product.producttypefiles')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProducttypefileFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
          <template slot="item.public" slot-scope="{ item }">
            <strong v-if="item.public" >
              <v-icon color="green">mdi-check-circle</v-icon>
            </strong>
            <span v-else>
              <v-icon color="red">mdi-close-circle</v-icon>
            </span>
          </template>
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProducttypefileFilterForm from '../../components/producttypefile/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';

export default {
  name: 'ProducttypefileList',
  servicePrefix: 'Producttypefile',
  mixins: [ListMixin,AccessMixin,FileMixin],
  components: {
    Toolbar,
    ActionCell,
    ProducttypefileFilterForm,
    DataFilter
  },
  props: {
    accessoryParent: {
      type: Array,
      required: false,
    },
    controlUnitParent: {
      type: Array,
      required: false,
    },
    machineParent: {
      type: Array,
      required: false,
    },
    materialSupplyParent: {
      type: Array,
      required: false,
    },
    softwareVersionParent: {
      type: Array,
      required: false,
    },
    industrialComputerParent: {
      type: Array,
      required: false,
    },
    operatingSystemParent: {
      type: Array,
      required: false,
    },
    optionMachineParent: {
      type: Array,
      required: false,
    },
    toolHeadParent: {
      type: Array,
      required: false,
    },
    materialProductVersionParent: {
      type: Array,
      required: false,
    },
  },
  data() {

    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('qualitycheck.product.producttypefiletype'), value: 'type.name' },
        { text: this.$t('global.language'), value: 'language' },
        { text: this.$t('profile.public'), value: 'public' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
      filters: {
        'accessory' : this.accessoryParent,
        'controlUnit' : this.controlUnitParent,
        'machine' : this.machineParent,
        'materialSupply' : this.materialSupplyParent,
        'softwareVersion' : this.softwareVersionParent,
        'industrialComputer' : this.industrialComputerParent,
        'operatingSystem' : this.operatingSystemParent,
        'optionMachine' : this.optionMachineParent,
        'toolHead' : this.toolHeadParent,
        'materialProductVersion' : this.materialProductVersionParent,

      },
      footer: {
        'itemsPerPageText': "",
      },

    };
  },
  computed: {
    ...mapGetters('producttypefile', {
      items: 'list'
    }),
    ...mapFields('producttypefile', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    hasLinkProduct() {
      if(this.accessoryParent) return true;
      if(this.controlUnitParent) return true;
      if(this.machineParent) return true;
      if(this.materialSupplyParent) return true;
      if(this.softwareVersionParent) return true;
      if(this.industrialComputerParent) return true;
      if(this.operatingSystemParent) return true;
      if(this.optionMachineParent) return true;
      if(this.toolHeadParent) return true;
      if(this.materialProductVersionParent) return true;
      return false;
    },
    parentProductFile() {
      if(this.accessoryParent) return this.accessoryParent;
      if(this.controlUnitParent) return this.controlUnitParent;
      if(this.machineParent) return this.machineParent;
      if(this.materialSupplyParent) return this.materialSupplyParent;
      if(this.softwareVersionParent) return this.softwareVersionParent;
      if(this.industrialComputerParent) return this.industrialComputerParent;
      if(this.operatingSystemParent) return this.operatingSystemParent;
      if(this.optionMachineParent) return this.optionMachineParent;
      if(this.toolHeadParent) return this.toolHeadParent;
      if(this.materialProductVersionParent) return this.materialProductVersionParent;
      return null;
    },
    parentRouteProductFile() {
      if(this.accessoryParent) return 'ProducttypefileAccessoryCreate';
      if(this.controlUnitParent) return 'ProducttypefileControlUnitCreate';
      if(this.machineParent) return 'ProducttypefileMachineCreate';
      if(this.materialSupplyParent) return 'ProducttypefileMaterialSupplyCreate';
      if(this.softwareVersionParent) return 'ProducttypefileSoftwareVersionCreate';
      if(this.industrialComputerParent) return 'ProducttypefileIndustrialComputerCreate';
      if(this.operatingSystemParent) return 'ProducttypefileOperatingSystemCreate';
      if(this.optionMachineParent) return 'ProducttypefileOptionMachineCreate';
      if(this.toolHeadParent) return 'ProducttypefileToolHeadCreate';
      if(this.materialProductVersionParent) return 'ProducttypefileMaterialProductVersionCreate';
      
      return null;
    }
  },
  methods: {
    ...mapActions('producttypefile', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
    addHandlerSpecial() {
      this.$router.push({
        name: this.parentRouteProductFile,
        params: { parent: this.parentProductFile[0] }
      });
    },
  }
};
</script>
